// extracted by mini-css-extract-plugin
export default {"wrapper":"EditHolidayGeneralForm_wrapper__MplkD","submitWrapper":"EditHolidayGeneralForm_submitWrapper__viLe9"};